import React from 'react'
import { Paper, useTheme } from '@mui/material'
import GppGoodIcon from '@mui/icons-material/GppGood'
import BoltIcon from '@mui/icons-material/Bolt'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import VerifiedIcon from '@mui/icons-material/Verified'
import Text from '../Text'

// Vantagens contadas pelo que a API Oficial muda de verdade. Nada de prometer
// número livre de bloqueio, entrega garantida ou selo aprovado: a Meta pode
// restringir qualquer número denunciado, a entrega depende do destinatário e o
// selo passa pela análise dela. Este bloco aparece na tela de conexão e no
// aviso de upgrade — vale o mesmo cuidado nos dois.
const BENEFITS = [
  {
    Icon: GppGoodIcon,
    title: 'Dentro das regras do WhatsApp',
    description: 'Envio pelas políticas oficiais do WhatsApp Business, com modelos de mensagem analisados pela Meta e a qualidade do número acompanhada aqui no painel.',
  },
  {
    Icon: BoltIcon,
    title: 'Sem QR Code nem celular ligado',
    description: 'Conexão oficial da Meta, sem depender do WhatsApp Web. Nada de reescanear QR Code nem de manter um aparelho conectado.',
  },
  {
    Icon: TrendingUpIcon,
    title: 'Cada envio acompanhado',
    description: 'O relatório mostra se a mensagem foi enviada, entregue e lida e, quando algo falha, o motivo explicado em português.',
  },
  {
    Icon: RocketLaunchIcon,
    title: 'Limite que cresce com o uso',
    description: 'A Meta pode subir o limite diário de conversas conforme o uso, desde que a qualidade das mensagens se mantenha boa.',
  },
  {
    Icon: VerifiedIcon,
    title: 'Selo de verificação',
    description: 'A empresa pode pedir o selo de verificação do WhatsApp Business, concedido pela Meta após análise.',
  },
]

function MetaOficialBenefits({ variant = 'card', heading = 'Por que migrar para a API Oficial' }) {
  const theme = useTheme()
  const isInline = variant === 'inline'

  const Wrapper = isInline ? 'div' : Paper
  const wrapperProps = isInline ? {} : { elevation: 2 }

  return (
    <Wrapper {...wrapperProps}>
      <div className={isInline ? '' : 'p-6'}>
        {heading && (
          <div className="mb-4">
            <Text className="text-base font-black uppercase tracking-wider">
              {heading}
            </Text>
            <div
              className="h-[3px] w-12 mt-2 rounded-full"
              style={{ backgroundColor: theme.palette.primary.main }}
            />
          </div>
        )}
        <div className="space-y-4">
          {BENEFITS.map(({ Icon, title, description }) => (
            <div key={title} className="flex items-start space-x-3">
              <div
                className="w-[36px] h-[36px] rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${theme.palette.primary.main}1A` }}
              >
                <Icon style={{ fontSize: 22, color: theme.palette.primary.main }} />
              </div>
              <div className="flex-1">
                <Text className="text-sm font-black leading-tight">
                  {title}
                </Text>
                <Text className="text-xs font-light mt-0.5 leading-snug opacity-90">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  )
}

export default MetaOficialBenefits
